module.exports = require("././dist/ng-twitter-api.js");


/*****************
 ** WEBPACK FOOTER
 ** ng-twitter-api (bower component)
 ** module id = 380
 ** module chunks = 1
 **/